import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { useSeoMeta } from '../hooks/useSeoMeta';
import { OG_IMAGE_URL } from '../pages/home-redesign/cityLinks';
import LegalPageShell from '../components/LegalPageShell';

const Privacy = () => {
  const { t, currentLanguage } = useLanguage();

  useSeoMeta({
    title: t('privacy.seoTitle'),
    description: t('privacy.seoDescription'),
    url: 'https://chisme.social/privacy',
    image: OG_IMAGE_URL,
    locale: currentLanguage === 'en' ? 'en' : 'es',
  });

  return (
    <LegalPageShell
      backLabel={t('privacy.backHome')}
      title={t('privacy.title')}
      lastUpdatedLabel={t('privacy.lastUpdated')}
      lastUpdatedDate={t('privacy.lastUpdatedDate')}
    >
      <h2>{t('privacy.section1.heading')}</h2>
      <p>{t('privacy.section1.para1')}</p>
      <p>{t('privacy.section1.para2')}</p>
      <p>{t('privacy.section1.para3')}</p>

      <h2>{t('privacy.section2.heading')}</h2>
      <p>{t('privacy.section2.para1')}</p>
      <p>
        {t('privacy.section2.contact')}
        <a href="mailto:privacy@chisme.social">privacy@chisme.social</a>
      </p>
      <p>{t('privacy.section2.para2')}</p>

      <h2>{t('privacy.section3.heading')}</h2>
      <h3>{t('privacy.section3.subsectionA.heading')}</h3>
      <ul>
        {(t('privacy.section3.subsectionA.items') as unknown as string[]).map((item, i) => (
          <li key={i}>{item}</li>
        ))}
      </ul>
      <h3>{t('privacy.section3.subsectionB.heading')}</h3>
      <ul>
        {(t('privacy.section3.subsectionB.items') as unknown as string[]).map((item, i) => (
          <li key={i}>{item}</li>
        ))}
      </ul>
      <h3>{t('privacy.section3.subsectionC.heading')}</h3>
      <ul>
        {(t('privacy.section3.subsectionC.items') as unknown as string[]).map((item, i) => (
          <li key={i}>{item}</li>
        ))}
      </ul>
      <h3>{t('privacy.section3.subsectionD.heading')}</h3>
      <p>{t('privacy.section3.subsectionD.para1')}</p>
      <p>{t('privacy.section3.subsectionD.para2')}</p>
      <h3>{t('privacy.section3.subsectionE.heading')}</h3>
      <p>{t('privacy.section3.subsectionE.para1')}</p>
      <p>{t('privacy.section3.note')}</p>

      <h2>{t('privacy.section4.heading')}</h2>
      <ul>
        {(t('privacy.section4.items') as unknown as string[]).map((item, i) => (
          <li key={i}>{item}</li>
        ))}
      </ul>

      <h2>{t('privacy.section4a.heading')}</h2>
      <p>{t('privacy.section4a.para1')}</p>
      <ul>
        {(t('privacy.section4a.items') as unknown as string[]).map((item, i) => (
          <li key={i}>{item}</li>
        ))}
      </ul>
      <p>{t('privacy.section4a.para2')}</p>

      <h2>{t('privacy.section4b.heading')}</h2>
      <p>{t('privacy.section4b.para1')}</p>
      <p>{t('privacy.section4b.notUsedForIntro')}</p>
      <ul>
        {(t('privacy.section4b.notUsedForItems') as unknown as string[]).map((item, i) => (
          <li key={i}>{item}</li>
        ))}
      </ul>
      <p>{t('privacy.section4b.para2')}</p>

      <h2 id="session-replay">{t('privacy.section4c.heading')}</h2>
      <p>{t('privacy.section4c.para1')}</p>
      <p>{t('privacy.section4c.neverIntro')}</p>
      <ul>
        {(t('privacy.section4c.neverItems') as unknown as string[]).map((item, i) => (
          <li key={i}>{item}</li>
        ))}
      </ul>
      <p>{t('privacy.section4c.para2')}</p>
      <p>{t('privacy.section4c.para3')}</p>
      <p>{t('privacy.section4c.para4')}</p>

      <h2>{t('privacy.section5.heading')}</h2>
      <ul>
        {(t('privacy.section5.items') as unknown as string[]).map((item, i) => (
          <li key={i}>{item}</li>
        ))}
      </ul>

      <h2>{t('privacy.section6.heading')}</h2>
      <p>{t('privacy.section6.intro')}</p>
      <ul>
        {(t('privacy.section6.items') as unknown as string[]).map((item, i) => (
          <li key={i}>{item}</li>
        ))}
      </ul>
      {(t('privacy.section6.attributionParas') as unknown as string[]).map((para, i) => (
        <p key={i}>{para}</p>
      ))}
      {(t('privacy.section6.businessParas') as unknown as string[]).map((para, i) => (
        <p key={i}>{para}</p>
      ))}
      <p>{t('privacy.section6.note')}</p>
      <p>{t('privacy.section6.verificationNote')}</p>

      <h2>{t('privacy.section7.heading')}</h2>
      <p>{t('privacy.section7.text')}</p>

      <h2>{t('privacy.section8.heading')}</h2>
      <ul>
        {(t('privacy.section8.items') as unknown as string[]).map((item, i) => (
          <li key={i}>{item}</li>
        ))}
      </ul>
      <p>{t('privacy.section8.verificationNote')}</p>

      <h2>{t('privacy.section9.heading')}</h2>
      <p>{t('privacy.section9.intro')}</p>
      <ul>
        {(t('privacy.section9.items') as unknown as string[]).map((item, i) => (
          <li key={i}>{item}</li>
        ))}
      </ul>
      <p>
        {t('privacy.section9.requestsText')}
        <a href="mailto:privacy@chisme.social">privacy@chisme.social</a>
      </p>

      <h2>{t('privacy.section10.heading')}</h2>
      <p>{t('privacy.section10.text')}</p>
      <p>{t('privacy.section10.verificationNote')}</p>

      <h2>{t('privacy.section11.heading')}</h2>
      <p>{t('privacy.section11.text')}</p>

      <h2>{t('privacy.section12.heading')}</h2>
      <p>{t('privacy.section12.text')}</p>

      <h2>{t('privacy.section13.heading')}</h2>
      <p>{t('privacy.section13.intro')}</p>
      <ul>
        <li>
          {t('privacy.section13.email')}
          <a href="mailto:privacy@chisme.social">privacy@chisme.social</a>
        </li>
        <li>{t('privacy.section13.address')}</li>
      </ul>
    </LegalPageShell>
  );
};

export default Privacy;
